<template>
  <div class="row">
    <el-dialog
      left
      title="Invite Team Member"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="isShow"
      width="516px"
      style="margin: 0 auto;"
      @close="handleCancel"
      class="diligence-dialog col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form>
        <div class="row" style="margin-bottom: 15px;">
          <div class="col-12">
            <div>
              Email
              <span class="required">*</span>
            </div>
            <!-- -->
            <vue-bootstrap-typeahead
              :data="usersList"
              v-model="email"
              v-if="value.isShow"
              ref="TeamRef"
              class="teamAutocompleteCls"
              :serializer="usersSerializer"
              :minMatchingChars="minMatchingChars"
              type="email"
              required
              placeholder="Enter Email"
              @hit="onAfterUserSelection"
            >
              <template slot="suggestion" slot-scope="{ data }">
                <div class="d-flex user-item">
                  <div v-if="data.image" style="margin-right:12px;">
                    <img
                      class="dd-icon"
                      style="border-radius:50%"
                      height="30"
                      width="30"
                      :src="data.image"
                    />
                  </div>
                  <div style="padding-top: 6px;">{{data.name}} {{emailShow(data.email)}}</div>
                </div>
              </template>
            </vue-bootstrap-typeahead>
          </div>
        </div>
        <div class="form-group">
          <div class="label">Role</div>
          <el-select
            class="todo-dropdown-el-select"
            size="large"
            placeholder="Select Role"
            v-model="value.data.role"
          >
            <el-option
              v-for="option in roles"
              class="select-primary"
              :disabled="checkDisabled(option.name)"
              :value="option._id"
              :label="option.name"
              :key="option._id"
            ></el-option>
          </el-select>
        </div>
        <div slot="footer" class="dialog-footer" style>
          <div style="border: 0.8px solid #EDEDED;opacity: 1;margin-top: 18px;display:none"></div>
          <div class="col-xl edit-company-action-button-row" style="padding: 0px;margin-top: 30px;">
            <button
              type="button"
              class="todo-form-cancel-button btn-outline-secondary"
              @click="value.isShow=!value.isShow;"
            >Cancel</button>
            <button
              type="button"
              class="todo-form-submit-button btn btn-primary"
              :disabled="checkValidation || isSaving"
              @click="formSubmit"
            >
              Save
              <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { mapGetters } from "vuex";
import workspace from "../../../store/modules/workspace";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Option.name]: Option,
    [Select.name]: Select,
    VueBootstrapTypeahead,
  },
  computed: {
    moment() {
      return moment;
    },
    ...mapGetters("referrer", ["teamMembers"]),
    checkRole() {
      let index = this.teamMembers.findIndex((item) =>
        item.account && item.account._id
          ? item.account._id == this.$route.params.account_id
          : -1
      );
      if (
        index >= 0 &&
        this.teamMembers[index] &&
        this.teamMembers[index].role &&
        this.teamMembers[index].role.name.length > 0
      )
        return this.teamMembers[index].role.name;
      else return "";
    },
    checkValidation() {
      let user, role;
      if (this.isSelected && this.email.length<=0) {
        user = this.value.data.user._id;
      } else if(this.email.length>0){
        user = this.email;
      }
      role = this.value.data.role;
      if(user && role) return false
      else return true
    },
    isShow: {
      get() {
        if (this.value.isShow) {
          this.intializeData();
        }
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
  },
  watch: {
    email: _.debounce(function (value) {
      if (value.length > 0) {
        this.getUsers(value);
      }
    }, 500),
  },
  props: {
    value: {
      isShow: Boolean,
      isReferrer: Boolean,
      data: Object,
    },
    roles: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      email: "",
      typeMaxResults: 5,
      minMatchingChars: 0,
      maxMatches: 6,
      usersList: [],
      isSelected: false,
      isSaving: false,
    };
  },
  mounted() {},
  methods: {
    checkDisabled(role) {
      let self = this;
      if (self.checkRole && self.checkRole.toLowerCase() == "manager") {
        if (role.toLowerCase() != "manager") return true;
      } else return false;
    },
    intializeData() {
      let self = this;
      setTimeout(() => {
        self.$refs.TeamRef.inputValue =
          this.value.data && this.value.data.email ? this.value.data.email : "";
        self.email =
          this.value.data && this.value.data.email ? this.value.data.email : "";
      }, 500);
    },
    emailShow(item) {
      let itemEmail = `<${item}>`;
      return itemEmail;
    },
    usersSerializer(data) {
      data.name =
        data.firstName != data.lastName
          ? `${data.firstName} ${data.lastName}`
          : data.firstName;
      if (data.cognito) data.email = data.cognito.email;
      else if (data.linkedin) data.email = data.linkedin.email;
      else if (data.google) data.email = data.google.email;
      else if (data.twitter) data.email = data.twitter.email;
      else if (data.facebook) data.email = data.facebook.email;
      else if (data.ltse) data.email = data.ltse.email;
      return data.email;
    },
    setValue(data) {
      let self = this;
      self.$refs.autocomplete.display = data;
      self.value.data.name = data;
    },
    handleCancel() {
      let self = this;
      self.isShow = false;
      self.usersList = [];
      self.email = "";
      self.isSaving = false;
      self.isSelected = false;
    },
    async getUsers(query) {
      let self = this;
      api
        .get(`/email/${query}`)
        .then((data) => {
          self.usersList = data.data.encrypt.success;
          self.usersList = self.usersList.filter(
            (item) => item._id != self.$route.params.account_id
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onAfterUserSelection(selectedValue) {
      this.value.data.user = selectedValue;
      this.isSelected = true;
      this.email = "";
    },
    duplicateEmailCheck(email) {
      let data = this.$store.getters["team/getAllUsers"];
      for (let i = 0; i < data.length; i++) {
        if (
          data[i] &&
          data[i].account &&
          data[i].account.cognito &&
          data[i].account.cognito.email &&
          data[i].account.cognito.email == email
        ) {
          return true;
          break;
        } else if (
          data[i] &&
          data[i].account &&
          data[i].account.linkedin &&
          data[i].account.linkedin.email &&
          data[i].account.linkedin.email == email
        ) {
          return true;
          break;
        } else if (
          data[i] &&
          data[i].account &&
          data[i].account.google &&
          data[i].account.google.email &&
          data[i].account.google.email == email
        ) {
          return true;
          break;
        } else if (
          data[i] &&
          data[i].account &&
          data[i].account.twitter &&
          data[i].account.twitter.email &&
          data[i].account.twitter.email == email
        ) {
          return true;
          break;
        } else if (
          data[i] &&
          data[i].account &&
          data[i].account.facebook &&
          data[i].account.facebook.email &&
          data[i].account.facebook.email == email
        ) {
          return true;
          break;
        } else if (
          data[i] &&
          data[i].account &&
          data[i].account.ltse &&
          data[i].account.ltse.email &&
          data[i].account.ltse.email == email
        ) {
          return true;
          break;
        } else {
          if (i == data.length - 1) {
            return false;
          }
        }
      }
    },
    AddReferrerAsTeam(data, payload) {
      let self = this;
      if (data.account && payload.referrer && payload.referrer.length > 0) {
        let payloadObj = {
          account: data.account,
          workspace: this.$route.params.workspace_id,
          referrer: payload.referrer,
        };
        this.$store
          .dispatch("referrer/apiAddReferrerTeam", payloadObj)
          .then((resp) => {
            self.$store.dispatch("referrer/getReffers");
            self.handleCancel();
            this.$toaster.success("Invitation has been sent");
          })
          .catch((err) => {
            this.isSaving = false;
            this.$toaster.error("Fail to add reffere to new account");
          });
      } else {
        self.$store.dispatch("referrer/getReffers");
        self.handleCancel();
        this.$toaster.success("Invitation has been sent");
      }
      self.$emit("user-success", {});
    },
    formSubmit() {
      let self = this;
      self.isSaving = true;
      let payload = {};
      payload.role = self.value.data.role;
      payload.workspace = self.$route.params.workspace_id;
      payload.isnewUser = false;
      let check;
      if (self.isSelected && self.email == "") {
        check = self.duplicateEmailCheck(self.value.data.user.email);
      } else {
        check = self.duplicateEmailCheck(self.email);
      }
      if (check && check == true) {
        this.$toaster.error("User with same email already exist.");
        this.email = "";
        this.isSaving = false;
        return;
      }
      if (self.isSelected && self.email == "") {
        payload.user = self.value.data.user._id;
        payload.email = self.value.data.user.email;
        this.$store
          .dispatch("team/apiInviteExistingUser", payload)
          .then((user) => {
            self.AddReferrerAsTeam(user, self.value.data);
          })
          .catch((err) => {
            this.email = "";
            this.isSaving = false;
            this.$toaster.error("Fail to invite the user.");
          });
      } else {
        let randomNo = Math.floor(Math.random() * 90000) + 10000;
        payload.email = self.email;
        payload.pswd = `Temp$${randomNo}`;
        let uname = self.email.split("@")[0];
        payload.name = uname;
        if (uname.length >= 3)
          payload.uname = uname.substr(0, 3) + new Date().valueOf();
        else payload.uname = payload.uname + new Date().valueOf();
        this.$store
          .dispatch("user/apiAddUser", payload)
          .then((user) => {
            this.$store
              .dispatch("team/apiInviteUser", payload)
              .then((workspace) => {
                self.AddReferrerAsTeam(workspace, self.value.data);
              })
              .catch((err) => {
                this.email = "";
                this.isSaving = false;
                this.message = err.response.data.message.includes("exists")
                  ? "User already exists."
                  : "Fail to invite the user.";
                this.$toaster.error(this.message);
              });
          })
          .catch((err) => {
            this.email = "";
            this.isSaving = false;
            this.message = err.response.data.message.includes("exists")
              ? "User already exists."
              : "Fail to invite the user.";
            this.$toaster.error(this.message);
            console.log({ err });
          });
      }
    },
  },
};
</script>
<style>
.teamAutocompleteCls .list-group-item {
  padding: 0px;
}
.user-item {
  padding-top: 10px;
  padding-bottom: 7px;
  padding-left: 7px;
}
</style>